import { FooterComponent } from './footer/footer.component';
import { TopNavComponent } from './top-nav/top-nav.component';

export const containers = [TopNavComponent, FooterComponent];

export * from './top-nav/top-nav.component';
export * from './footer/footer.component';
